import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Overview from '../components/Overview.vue'
import AddClientView from '../views/AddClientView.vue'
import ClientView from '../views/ClientView.vue'
import ActivityHistoryView from '../components/activity/ActivityHistoryView.vue'
import { msalInstance } from '../auth/msalInstance'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: Overview
  },
  {
    path: '/add-client',
    name: 'addClient',
    component: AddClientView
  },
  {
    path: '/client/:id',
    name: 'client',
    component: ClientView
  },
  {
    path: '/activity-history',
    name: 'activityHistory',
    component: ActivityHistoryView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const accounts = msalInstance.getAllAccounts()
  if (to.path !== '/login' && accounts.length === 0) {
    sessionStorage.setItem('redirectPath', to.fullPath)
    next('/login')
  } else {
    next()
  }
})

export default router
